// Captures and persists Meta Ads / UTM attribution for the whole visitor session.
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const STORAGE_KEY = "gfx_attribution";

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const hasAny = KEYS.some((k) => params.get(k));
    if (!hasAny) return;

    const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    const merged = { ...existing };
    KEYS.forEach((k) => {
      const val = params.get(k);
      if (val) merged[k] = val;
    });
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (err) {
    // sessionStorage unavailable (e.g. private mode) — attribution is best-effort
  }
}

export function getAttribution() {
  let stored = {};
  try {
    stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (err) {
    stored = {};
  }
  return KEYS.reduce((acc, k) => {
    acc[k] = stored[k] || "";
    return acc;
  }, {});
}
